<template>
    <div class="obj-list wrapper ofh" style="padding-bottom:180px;" v-loading.fullscreen.lock="loading"
        :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="page__card">
            <div class="page__card-title">
                <h1>{{ $t('reports') }}</h1>
            </div>
            <div class=" all-reports">
                <div class="flex flex-wrap -m-1">
                    <div v-if="['admin', 'org_admin', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)" 
                        class="w-full lg:w-1/2 2xl:w-1/3 p-1">
                        <div class="report__card">
                            <div class="report__card-head">
                                <h1 class="report__card-title">{{ $t('all_building_structures_reports') }}</h1>
                            </div>
                            
                            <div class="report__card-body">
                                <button class="report__download"
                                    @click="DownloadExel(`/building/generate/${me.role.name !== 'admin' ? '/orgadmin' : ''}buildingstatistic/`, 'Ҳисобот барча бино')">
                                    <img width="20" class="report__download-icon" src="@/assets/img/icons/xls.svg"
                                        alt="xls svg">
                                    <div class="report__download-text">
                                        <p class="report__download-title">{{ $t('download_report') }} </p>
                                    </div>
                                    <div class="report__download-action">
                                        <img width="20" src="@/assets/img/icons/file-download.svg"
                                            alt="file download svg">
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="['admin', 'org_admin', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)"
                        class="w-full lg:w-1/2 2xl:w-1/3 p-1">
                        <div class="report__card">
                            <div class="report__card-head">
                                <h1 class="report__card-title">{{ $t('regional_building_report') }}</h1>
                                <div class="report__card-select">
                                    <el-select :placeholder="$t('region')" v-model="filter_regions.region0" clearable>
                                        <el-option v-for="(item, i) in regions" :key="item.id"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="i + 1">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="report__card-body">
                                <button class="report__download"
                                    :class="{ 'cursor-not-allowed': !filter_regions.region0 }"
                                    :disabled="!filter_regions.region0"
                                    @click="DownloadExel(`/building/generate/${me.role.name !== 'admin' ? '/orgadmin' : ''}buildinggroups/${regions[filter_regions.region0 - 1].id}/`, `Ҳудудий бинолар ҳисоботи ${regions[filter_regions.region0 - 1].name_cyr}`)">
                                    <img width="20" class="report__download-icon" src="@/assets/img/icons/xls.svg"
                                        alt="xls svg">
                                    <div class="report__download-text">
                                        <p class="report__download-title">{{ $t('download_report') }} </p>
                                        <p v-show="!filter_regions.region0" class="report__download-subtitle"> {{
                                            $t('choose_report') }} </p>
                                    </div>
                                    <div class="report__download-action">
                                        <img width="20" src="@/assets/img/icons/file-download.svg"
                                            alt="file download svg">
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="['admin', 'org_admin', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)"
                        class="w-full lg:w-1/2 2xl:w-1/3 p-1">
                        <div class="report__card">
                            <div class="report__card-head">
                                <h1 class="report__card-title">{{ $t('hydrotechniks_report') }}</h1>
                            </div>
                            <div class="report__card-body">
                                <button class="report__download"
                                    @click="DownloadExel(`/building/generate/${me.role.name !== 'admin' ? '/orgadmin' : ''}reservoirstatistic/`, 'Ҳисобот Гидротехник иншоотлар')">

                                    <img width="20" class="report__download-icon" src="@/assets/img/icons/xls.svg"
                                        alt="xls svg">
                                    <div class="report__download-text">
                                        <p class="report__download-title">{{ $t('download_report') }} </p>
                                    </div>
                                    <div class="report__download-action">
                                        <img width="20" src="@/assets/img/icons/file-download.svg"
                                            alt="file download svg">
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="w-full lg:w-1/2 p-1">
                        <div class="report__card">
                            <div class="report__card-head">
                                <h1 class="report__card-title">{{ $t('an_incomplete_building_report') }}</h1>
                            </div>
                            <div class="report__card-body">
                                <div class="flex flex-wrap -m-1 mb-2">
                                    <el-select v-if="me.role.name == 'admin'" placeholder="Ташкилотлар"
                                        class="w-full sm:w-1/2 p-1" v-model="organization" clearable>
                                        <el-option v-for="(item, i) in organizations" :key="i" :label="item.name"
                                            :value="i + 1"></el-option>
                                    </el-select>
                                    <el-select :placeholder="$t('region')" :disabled="!organization"
                                        v-model="filter_regions.region1" class="w-full sm:w-1/2 p-1" clearable>
                                        <el-option v-for="(item, i) in regions" :key="item.id"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="i + 1">
                                        </el-option>
                                    </el-select>
                                </div>
                                <button class="report__download"
                                    :class="{ 'cursor-not-allowed': !filter_regions.region1 }"
                                    :disabled="!filter_regions.region1"
                                    @click="DownloadExel(`/building/generate/incompletebuildings${organization == 1 ? '' : organization}/${regions[filter_regions.region1 - 1].id}/`, `${organizations[organization - 1].short} ${regions[filter_regions.region1 - 1].name_cyr}`)">

                                    <img width="20" class="report__download-icon" src="@/assets/img/icons/xls.svg"
                                        alt="xls svg">
                                    <div class="report__download-text">
                                        <p class="report__download-title">{{ $t('download_report') }} </p>
                                        <p v-if="!filter_regions.region1" class="report__download-subtitle">
                                            {{ me.role.name == 'admin' ?
                                            $t('choose_organisation_region') : $t('choose_report') }}
                                        </p>
                                    </div>
                                    <div class="report__download-action">
                                        <img width="20" src="@/assets/img/icons/file-download.svg"
                                            alt="file download svg">
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="w-full 2xl:w-1/2 p-1">
                        <div class="report__card">
                            <div class="report__card-head">
                                <h1 class="report__card-title">{{ $t('organisation_piace_all_report') }}</h1>
                            </div>
                            <div class="report__card-body">
                                <div class="flex flex-wrap -m-1 mb-2">
                                    <el-select v-if="me.role.name == 'admin'" :placeholder="$t('organizations')"
                                        class="cut-text w-full sm:w-1/2 md:w-1/4 p-1"  v-model="org_id" clearable>
                                        <el-option class="cut-text" v-for="(item, i) in OrganizarionsList" :key="i"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="item.id"></el-option>
                                    </el-select>
                                    <el-select placeholder="Ташкилот" v-if="me.role.name == 'admin'" :disabled="!org_id"
                                        v-model="org_child_id"  clearable class="w-full sm:w-1/2 md:w-1/4 p-1">
                                        <el-option class="cut-text " v-for="(item, i) in OrganizarionsListChild" :key="i"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <el-select v-if="me.role.name === 'admin'" placeholder="Регион"
                                        v-model="filterRegion"  clearable class=" w-full sm:w-1/2 md:w-1/4 p-1">
                                        <el-option class="cut-text" v-for="(item, i) in regions" :key="i"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="i + 1"></el-option>
                                    </el-select>

                                    <el-select v-if="me.role.name === 'admin'" placeholder="Туман"
                                        :disabled="!filterRegion" v-model="filterDistrict" 
                                        class="w-full sm:w-1/2 md:w-1/4 p-1"
                                        clearable>
                                        <el-option class="cut-text" v-for="(item, i) in current_district" :key="i"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </div>
                                <button class="report__download" :class="{ 'cursor-not-allowed': !org_child_id }"
                                    :disabled="!org_child_id"
                                    @click="DownloadExel(`/building/generate/statistic/organization/${org_child_id}/`, `Ташкилот Ҳисоботи`)">

                                    <img width="20" class="report__download-icon" src="@/assets/img/icons/xls.svg"
                                        alt="xls svg">
                                    <div class="report__download-text">
                                        <p class="report__download-title">{{ $t('download_report') }} </p>
                                        <p v-if="!org_child_id" class="report__download-subtitle">
                                            {{ me.role.name == 'admin' ?
                                            $t('choose_organisation_region') : $t('choose_report') }}
                                        </p>
                                    </div>
                                    <div class="report__download-action">
                                        <img width="20" src="@/assets/img/icons/file-download.svg"
                                            alt="file download svg">
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hr"></div>
            <div class="constructor__top">
                <IconLogo class="constructor__top-logo" />
                <div>
                    <h1 class="constructor__top-title">Хисоботлар <span>Конструктори</span></h1>
                </div>
                <div class="flex-1"></div>
                <p class="constructor__top-info">{{ $t('all_count') }}: {{ reportsList.length }}</p>
                <button v-if="me.role.name !== 'supervisor'" class="add__button" @click="dialogVisible = true">
                    {{ $t('add_report') }}
                    <HAddCircle />
                </button>
            </div>

            <div class="constructor__body">
                <h1 class="constructor__body-title">{{ $t('report_samples')}}</h1>
                <div>
                    <el-empty v-if="!reportsList.length" v-loading="loadingReports"
                        :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)" :description="$t('empty')" />
                    <div v-if="reportsList.length"  class="flex flex-col gap-1"  v-loading="loadingReports"
                        :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)">
                        <div v-for="(report, index) in reportsList" :key="index" class="report_exemples">
                            <img width="40" class="report_exemples-icon" src="@/assets/img/icons/xls.svg" alt="xls svg">
                            <div class="report_exemples-text flex-1">
                                <h1 class="report_exemples-title">{{ report.file_name }}</h1>
                                <p class="report_exemples-subtitle">{{ new
                                    Date(report.created_at).toLocaleDateString("ru-RU") }}</p>
                            </div>
                            <div class="report_exemples-buttons flex gap-2">
                                <button class="report_exemples-buttons--download" @click="downloadReport(report)">
                                    <HFileDownload />
                                </button>
                                <button v-if="me.role.name !== 'supervisor'" class="report_exemples-buttons--edit" @click="openEditModal(report)">
                                    <HEdit />
                                </button>
                                <button v-if="me.role.name !== 'supervisor'" class="report_exemples-buttons--delete" @click="deleteReport(report.id)">
                                    <HTrash />
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="report.id ? $t('edit_report') : $t('create_report')" :visible.sync="dialogVisible"
            :show-close="false" width="min(700px, 95%)" @close="closeDialog">
            <div class="step overflow-hidden w-full">
                <div class="step__item" :class="{'active' : step === 1, 'done' : step > 1}">
                    <p class="step__number">1</p>
                    <p class="step__text truncate">{{$t('filters')}}</p>
                </div>
                <div class="step__item" :class="{ 'active': step === 2, 'done': step > 2 }">
                    <p class="step__number">2</p>
                    <p class="step__text truncate">{{ $t('columns') }}</p>
                </div>
                <div class="step__item" :class="{ 'active': step === 3, 'done': step > 3 }">
                    <p class="step__number">3</p>
                    <p class="step__text truncate">{{ $t('report_informations') }} </p>
                </div>
            </div>
            <div class="report_hr"></div>
            <el-form v-show="step === 1" :model="query" ref="formQuery">
                <div class="flex flex-wrap -m-1">
                    <div class="p-1 w-full sm:w-1/2">
                        <el-form-item prop="building_group" :label="$t('building_category')" :rules="{
                            required: true,
                            message: this.$t('please_enter_data'),
                            trigger: 'change',
                        }" style="margin-bottom: 12px;">
                            <el-select :placeholder="$t('building_category')" class="w-full" v-model="query.building_group"
                                clearable>
                                <el-option v-for="(item, i) in building_group" :key="i" class="cut-text"
                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                    :value="''+item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="p-1 w-full sm:w-1/2">
                        <el-form-item prop="organization" :label="$t('organizations')" :rules="{
                            required: true,
                            message: this.$t('please_enter_data'),
                            trigger: 'change',
                        }" style="margin-bottom: 12px;">
                            <el-select
                                v-model="query.organization"
                                filterable
                                remote
                                class="w-full"
                                :placeholder="$t('organizations')"
                                :remote-method="getOrganizations"
                                clearable
                                @visible-change="onVisibleChange"
                                ref="orgSelect"
                                :loading="loadingOrganizations"
                                >
                                    <el-option
                                        v-for="item in reportSampleOrganizations"
                                        :key="item.id"
                                        :label="item[`name_${$i18n.locale}`]"
                                        :value="''+item.id"
                                        class="max-w-md"
                                        >
                                    </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="p-1 w-full sm:w-1/2">
                        <el-form-item prop="region" :label="$t('transport_region')" 
                         style="margin-bottom: 12px;">
                            <el-select :placeholder="$t('transport_region')" class="w-full" v-model="query.region"
                                clearable @change="getDistricts">
                                <el-option v-for="(item, i) in regions" :key="i" class="cut-text"
                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                    :value="''+item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="p-1 w-full sm:w-1/2">
                        <el-form-item prop="district" :label="$t('district')"  style="margin-bottom: 12px;">
                            <el-select :placeholder="$t('district')" class="w-full" :disabled="!query.region"
                                v-model="query.district" clearable>
                                <el-option v-for="(item, i) in current_district" :key="i" class="cut-text"
                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                    :value="''+item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="p-1 w-full">
                        <el-form-item prop="buildingtype" :label="$t('structure_type')" :rules="{
                            required: true,
                            message: this.$t('please_enter_data'),
                            trigger: 'change',
                        }" style="margin-bottom: 12px;">
                            <el-select :placeholder="$t('structure_type')" class="w-full" v-model="query.buildingtype"
                                clearable>
                                <el-option class="cut-text" :label="$t('building_type_new')" value="NEW"></el-option>
                                <el-option class="cut-text" :label="$t('building_type_exg')" value="EXG"></el-option>

                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <el-form v-show="step!==1" :model="report" ref="formReport">
                <div>
                    <el-form-item v-if="step == 2" prop="fields" :label="$t('selecting_columns')" :rules="{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: 'change',
                    }">
                        <el-select :placeholder="$t('selecting_columns')" class="w-full" v-model="report.fields"
                            clearable multiple collapse-tags filterable>
                            <el-option v-for="(item, i) in columns" :key="i" class="cut-text"
                                :label="item[`${$i18n.locale}`]" :value="item.value"></el-option>
                        </el-select>
                        <div class="draggable__fields">
                            <Container @drop="onDrop">
                                <Draggable v-for="item in report.fields" :key="item">
                                    <div class="draggable-item">
                                        <p>{{columns.find(col => col.value === item)[`${$i18n.locale}`] }}</p>
                                        <IconDraggable />
                                    </div>
                                </Draggable>
                            </Container>
                        </div>
                    </el-form-item>
                </div>
                <el-form-item v-if="step == 3" prop="file_name" :label="$t('file_name')" :rules="{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: 'change',
                }" style="margin-bottom: 12px;">

                    <el-input name="file_name" v-model="report.file_name" :placeholder="$t('file_name')" />
                </el-form-item>
                <el-form-item v-if="step == 3" prop="file_title" :label="$t('file_title')" :rules="{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: 'change',
                }" style="margin-bottom: 12px;">

                    <el-input name="file_title" v-model="report.file_title" :placeholder="$t('file_title')" />
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <div class="flex flex-wrap items-center">
                    <UIcheckbox v-if="step===3" v-model="report.save_template" :disabled="!!report.id">
                        <p class="ml-2 leading-snug font-semibold" style="color: #020617;">{{ $t('save_as_sample') }}</p>
                    </UIcheckbox>
                    <div class="flex-1"></div>
                    <el-button v-if="step == 1" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
                    <el-button v-if="step > 1" @click="step--">{{ $t('back') }}</el-button>
                    <el-button v-if="step < 3" type="primary" @click="nextStep()">
                        <div class="flex items-center gap-2">
                            {{ $t('continue') }}
                            <HDirectionRight01 />
                        </div>
                    </el-button>
                    <button :disabled="loadingEditReport" v-if="step == 3" class="add__button ml-2.5" @click="nextStep">
                        {{ $t('formation')}}
                        <HLoading v-if="loadingEditReport" :class="{ spin : loadingEditReport}" />
                    </button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HAddCircle from '../components/Icons/hAddCircle.vue';
import HDirectionRight01 from '../components/Icons/hDirectionRight01.vue';
import HEdit from '../components/Icons/hEdit.vue';
import HFileDownload from '../components/Icons/hFileDownload.vue';
import HLoading from '../components/Icons/hLoading.vue';
import HTrash from '../components/Icons/hTrash.vue';
import IconDraggable from '../components/Icons/iconDraggable.vue';
import IconLogo from '../components/Icons/iconLogo.vue';
import UIcheckbox from "@/components/ui/Checkbox.vue";
import { Container, Draggable } from "vue-dndrop";

export default {
    components: {
        IconLogo,
        HAddCircle,
        HDirectionRight01,
        UIcheckbox,
        HFileDownload,
        HEdit,
        HTrash,
        HLoading,
        Container,
        Draggable,
        IconDraggable
    },
    data() {
        return {
            step: 1,
            region: '',
            loading: false,
            loadingDistricts: false,
            loadingOrganizations: false,
            loadingEditReport: false,
            dialogVisible: false,
            reportsList: [],
            loadingReports: false,
            offset: 0,
            search: '',
            count: 0,
            query: {
                building_group: undefined,
                organization: undefined,
                region: undefined,
                district: undefined,
                buildingtype: undefined,

            },
            editDataReport: {},
            report: {
                id: '',
                file_title: "",
                file_name: "",
                fields: ['id'],
                save_template: false
            },
            rules: [],
            filter_regions: {
                region0: '',
                region1: '',
                region2: '',
                region3: '',
                region4: '',
            },
            filterRegion: '',
            filterDistrict: '',
            current_district: {},
            organization: "",
            reportSampleOrganizations: [],
            organizations: [
                { name: 'Ўзбекистон Республикаси Халқ таълими вазирлиги', short: 'ЎзРес Халқ таълими вазирлиги', id: 1, org_id: '2675' },
                { name: 'Ўзбекистон Республикаси  Соғлиқни сақлаш вазирлиги', short: 'ЎзРес Соғлиқни сақлаш вазирлиги', id: 2, org_id: '3737' },
                { name: 'Ўзбекистон Республикаси Мактабгача таълим вазирлиги', short: 'ЎзРес Мактабгача таълим вазирлиги', id: 3, org_id: '8209' },
                { name: 'Ўзбекистон Республикаси Уй-жой коммунал хизмат кўрсатиш вазирлиги', short: 'ЎзРес Халқ  Уй-жой коммунал хизмат кўрсатиш вазирлиги', id: 4, org_id: '4061' },
            ],
            OrganizarionsList: [],
            OrganizarionsListChild: [{}],
            org_id: '',
            org_child_id: null,
            columns: [
                { "cyr": "ID", "ru": "ID", "value": "id" },
                { "cyr": "Кадастрал номер", "ru": "Кадастровый номер", "value": "cadastral_number" },
                { "cyr": "Кадастрал номер олд", "ru": "Кадастровый номер старый", "value": "cadastral_number_old" },
                { "cyr": "Регион", "ru": "Регион", "value": "region" },
                { "cyr": "Туман", "ru": "Район", "value": "district" },
                { "cyr": "Маҳалла", "ru": "Махалля", "value": "neighborhood" },
                { "cyr": "Манзил", "ru": "Адрес", "value": "address" },
                { "cyr": "Йил қурилган", "ru": "Год постройки", "value": "year_construction" },
                { "cyr": "Бино сейсмикалиги", "ru": "Сейсмичность здания", "value": "buildingseismicity" },
                { "cyr": "Конструктив ечим", "ru": "Конструктивное решение", "value": "constructivesolution" },
                { "cyr": "Режалаштирилган шакл", "ru": "Планируемая форма", "value": "plannedshape" },
                { "cyr": "Қаватлар сони", "ru": "Число этажей", "value": "numberfloors" },
                { "cyr": "Умумий ҳажм", "ru": "Общая площадь", "value": "overall_size" },
                { "cyr": "Қаватлар баландлиги", "ru": "Высота этажей", "value": "floors_height" },
                { "cyr": "Часть чердак", "ru": "Часть чердак", "value": "part_attic" },
                { "cyr": "Техник баландлик", "ru": "Техническая высота", "value": "technical_height" },
                { "cyr": "Подвал мавжудлиги", "ru": "Наличие подвала", "value": "basement_presence" },
                { "cyr": "Секцияларга бўлинган", "ru": "Разделено на секции", "value": "divided_into_sections" },
                { "cyr": "Баланс қиймати", "ru": "Балансовая стоимость", "value": "balance_value" },
                { "cyr": "Фундамент тури", "ru": "Тип фундамента", "value": "foundation_type" },
                { "cyr": "Несуўчи", "ru": "Несущие", "value": "load_bearing" },
                { "cyr": "Перекрития", "ru": "Перекрытия", "value": "coverings" },
                { "cyr": "Том қисми", "ru": "Секция крыши", "value": "roofsection" },
                { "cyr": "Секциялар сони", "ru": "Число секций", "value": "divisions_number" },
                { "cyr": "Секция параметрлари", "ru": "Параметры секции", "value": "section_parameters" },
                { "cyr": "Тўсин девор қадами", "ru": "Шаг поперечных стен", "value": "transverse_wall_step" },
                { "cyr": "Узун девор", "ru": "Продольная стена", "value": "longitudinal_wall" },
                { "cyr": "Узун девор қадами", "ru": "Шаг продольных стен", "value": "longitudinal_wall_spacing" },
                { "cyr": "Сейсмик камарлар", "ru": "Сейсмопояса", "value": "seismicbelts" },
                { "cyr": "Боғловчи камарлар", "ru": "Соединительные пояса", "value": "connectingbelts" },
                { "cyr": "Ойналар оралиғи", "ru": "Шаг окон", "value": "window_spacing" },
                { "cyr": "Парделар", "ru": "Занавески", "value": "curtains" },
                { "cyr": "Бетон класи", "ru": "Класс бетона", "value": "concrete_class" },
                { "cyr": "Ғишт маркаси", "ru": "Марка кирпича", "value": "brick_brand" },
                { "cyr": "Аралашма класи", "ru": "Класс смеси", "value": "mixture_class" },
                { "cyr": "Грунт тури", "ru": "Тип грунта", "value": "soil_type" },
                { "cyr": "Арматура класи", "ru": "Класс арматуры", "value": "armature_class" },
                { "cyr": "Пўлат чидамлилиги", "ru": "Прочность стали", "value": "steel_resistance" },
                { "cyr": "Ғишт ёки тош девор тури", "ru": "Тип кирпичной или каменной стены", "value": "brick_or_stone_wall_type" },
                { "cyr": "Мустаҳкамлик заҳираси аниқлаш", "ru": "Определение запаса прочности", "value": "determination_endurance_reserve" },
                { "cyr": "Лойиҳалаш", "ru": "Проектирование", "value": "projection" },
                { "cyr": "Лойиҳа ташкилоти номи", "ru": "Название проектной организации", "value": "project_organization_name" },
                { "cyr": "Қурилиш-монтаж ишлари", "ru": "Строительно монтажные работы", "value": "construction_installation_works" },
                { "cyr": "Хусусиятлари", "ru": "Свойства", "value": "properties" },
                { "cyr": "Ҳудуд сейсмикалиги", "ru": "Сейсмичность района", "value": "seismicity_area" },
                { "cyr": "Муҳандислик коммуникациялари", "ru": "Инженерные коммуникации", "value": "communication_engineering" },
                { "cyr": "Мустаҳкамлик ишончлилиги", "ru": "Прочность надежность", "value": "robustness_reliability" },
                { "cyr": "Жорий ҳолати", "ru": "Текущее состояние", "value": "dailycondition" },
                { "cyr": "Якуний хулоса", "ru": "Окончательное заключение", "value": "finalconclusion" },
                { "cyr": "Зилзиладаги ҳолати", "ru": "Состояние при землетрясении", "value": "earthquakecondition" },
                { "cyr": "Бино гуруҳи", "ru": "Группа здания", "value": "building_group" }
            ]


        };
    },
    computed: {
        regions() {
            return this.$store.state.dictionary.region;
        },
        me() {
            return this.$store.state.me;
        },
        building_group() {
            return this.$store.state.dictionary.buildinggroup;
        },
    },
    watch: {
        me() {
            if (!['admin', 'org_admin', 'main_org_admin', 'supervisor'].includes(this.me.role.name)) {
                this.$router.push('/404')
            }
            else if (this.me.role.name == 'org_admin' || this.me.role.name == 'ministry_admin' || this.me.role.name == 'main_org_admin') {
                if (this.me.organization && this.me.organization.id == 2675) {
                    this.organization = 1
                }
                if (this.me.organization && this.me.organization.id == 3737) {
                    this.organization = 2
                }
                if (this.me.organization && this.me.organization.id == 8209) {
                    this.organization = 3
                }
                if (this.me.organization && this.me.organization.id == 4061) {
                    this.organization = 4
                }
            }
            if (this.me.role.name == 'admin') {
                axios.get('/organization/?limit=15&level=1')
                    .then((response) => {
                        this.OrganizarionsList = response.data.results;
                        // this.loading = false;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
            else if (this.me.role.name == 'org_admin' || this.me.role.name == 'ministry_admin' || this.me.role.name == 'main_org_admin') {
                this.org_child_id = this.me.organization.id
            }
        },
        org_id(val) {
            this.org_child_id = null
            axios.get(`/organization/${val}/`)
                .then((response) => {
                    this.OrganizarionsListChild = response.data.children;
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        organization() {
            this.filter_regions.region1 = ""
        },
        filterRegion(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.filterDistrict = ''
                this.getDistrict()
            }
        }
    },
    mounted() {
        this.getReportsList()
        this.getOrganizations()
        if (!['admin', 'org_admin', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(this.me.role.name)) {
            this.$router.push('/404')
        }
        else if (this.me.role.name == 'org_admin' || this.me.role.name == 'ministry_admin' || this.me.role.name == 'main_org_admin') {
            if (this.me.organization && this.me.organization.id == 2675) {
                this.organization = 1
            }
            if (this.me.organization && this.me.organization.id == 3737) {
                this.organization = 2
            }
            if (this.me.organization && this.me.organization.id == 8209) {
                this.organization = 3
            }
            if (this.me.organization && this.me.organization.id == 4061) {
                this.organization = 4
            }
        }
        if (this.me.role.name == 'admin') {
            axios.get('/organization/?limit=15&level=1')
                .then((response) => {
                    this.OrganizarionsList = response.data.results;
                    // this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                })
        }
        else if (this.me.role.name == 'org_admin' || this.me.role.name == 'ministry_admin' || this.me.role.name == 'main_org_admin') {
            this.org_child_id = this.me.organization.id
        }
    },
    methods: {
        getReportsList() {
            this.loadingReports = true
            axios.get(`/building/export-templates/`)
                .then(response => {
                    this.reportsList = response.data;
                })
                .finally(() => {
                    this.loadingReports = false;
                });

        },
        DownloadExel(baseURL, name) {
            this.loading = true
            let url = `${baseURL}`

            if (this.filterRegion && !this.filterDistrict) {
                url += `?region=${encodeURIComponent(this.filterRegion)}`
            }
            else if (this.filterRegion && this.filterDistrict) {
                url += `?region=${encodeURIComponent(this.filterRegion)}&district=${encodeURIComponent(this.filterDistrict)}`
            }
            axios({
                url: url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', `${name}` + ".xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);
            })
                .finally(() => {
                    this.loading = false
                })
        },
        getDistrict() {
            axios
                .get(`/dictionary/district/?region=${this.filterRegion}`)
                .then((response) => {
                    this.current_district = response.data;
                })
        },

        getOrganizations(search, offset) {
            this.search = search;
            if(offset > 0 && offset > this.count) return;
            this.loadingOrganizations = true;
            if (!offset) {
                this.offset = 0;
                this.reportSampleOrganizations = []
            }
            axios.get(`/organization/`, { params: { search, offset, limit: 30 } })
                .then(response => {
                    offset ? this.reportSampleOrganizations.push(...response.data.results) : this.reportSampleOrganizations = response.data.results;
                    this.count = response.data.count
                })
                .catch(() => {
                    this.reportSampleOrganizations = [];
                })
                .finally(() => {
                    this.loadingOrganizations = false;
                });
        },
        onVisibleChange(val) {
            const dropdown = this.$refs.orgSelect.$refs.scrollbar.wrap;
            if (val) {
                dropdown.addEventListener("scroll", this.handleScroll);
            }
            else {
                dropdown.removeEventListener("scroll", this.handleScroll);
                this.offset = 0
                this.count = 0
                this.search = ''
                this.getOrganizations()
            }
        },
        handleScroll(e) {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            if (scrollTop + clientHeight >= scrollHeight - 10 && !this.loadingOrganizations) {
                this.offset += 30
                this.getOrganizations(this.search, this.offset);
            }
        },
        getDistricts(id, notClear) {
            if (!notClear) this.query.district = undefined;
            if (!id) return;
            this.current_district = [];
            this.loadingDistricts = true;
            axios.get(`/dictionary/district/?region=${id}`)
                .then(response => {
                    this.current_district = response.data;
                })
                .catch(() => {
                    this.current_district = [];
                })
                .finally(() => {
                    this.loadingDistricts = false;
                });
        },
        nextStep() {
            this.$refs[this.step === 1 ? 'formQuery' : 'formReport'].validate((valid) => {
                if (valid) { 
                    if (this.step === 3) {
                        this.report.id ? this.patchReport() : this.postReport()
                    } else {
                        this.step++
                    }
                }
            })
        },
        postReport() {
            this.loadingEditReport = false
                axios.post(`/building/export/specification/`, this.report, { params: this.query, responseType: 'blob', })
                .then(response => {
                    this.dialogVisible = false
                    this.getReportsList()
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${this.report.file_name}` + ".xlsx");
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                })
                .catch((error) => {
                    this.$swal.fire({
                        icon: "error",
                        title: this.$i18n.locale === 'cyr' ? "Ҳисобот намунасини учиришда хатолик" :"Ошибка при удалении образца отчета.",
                        timer: 3000,
                    });

                })
                .finally(() => {
                    this.loadingEditReport = false;
                });
        },
        patchReport() {
            let params = {}
            let data = {}

            Object.keys(this.query).forEach(key => {
                if (this.query[key] !== this.editDataReport.filters[key]?.[0]) {
                    params[key] = this.query[key]
                }
            })

            Object.keys(this.report).forEach(key => {
                if (key !== 'save_template' && this.report[key] !== this.editDataReport[key]) {
                    data[key] = this.report[key]
                }
            })
            if (Object.keys(params).length == 0 && Object.keys(data).length == 0) {
                this.$message.warning(
                    this.$i18n.locale === 'cyr' ? "Ҳеч нарса ўзгармаган" :"Ничего не изменилось.",
                );
                return
            }
            data.template = this.editDataReport.id
            data.save_template = true
            
            this.loadingEditReport = false
            axios.patch(`/building/export/specification/`, data, { params: this.query, responseType: 'blob', })
                .then(response => {
                    this.dialogVisible = false
                    this.getReportsList()
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${this.report.file_name}` + ".xlsx");
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                })
                .catch((error) => {
                    this.$swal.fire({
                        icon: "error",
                        title: this.$i18n.locale === 'cyr' ? "Ҳисобот намунасини учиришда хатолик" : "Ошибка при удалении образца отчета.",
                        timer: 3000,
                    });
                })
                .finally(() => {
                    this.loadingEditReport = false;
                });
        },
        closeDialog() {
            
            this.step = 1
            this.query = {
                building_group: undefined,
                organization: undefined,
                region: undefined,
                district: undefined,
                buildingtype: undefined,
            },
            
            this.report = {
                id: "",
                file_title: "",
                file_name: "",
                fields: ['id'],
                save_template: false
                },
            this.editDataReport = {}
            this.$refs.formQuery.resetFields()
            this.$refs.formReport.resetFields()
        },
        openEditModal(data) {
            this.editDataReport = data
            // this.query = data.filters
            Object.keys(this.query).forEach(key => {
                this.query[key] = this.editDataReport.filters[key]?.[0]
            })
            this.getDistricts(this.query.region, true)

            Object.keys(this.report).forEach(key => {
                this.report[key] = this.editDataReport[key]
            })
            this.report.id = this.editDataReport.id
            this.report.save_template = true
            this.dialogVisible = true
            
        },
        deleteReport(id) {
            return this.$confirm(this.$t('do_delete_report'), {
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then(() => {
                axios
                    .delete(`/building/export/specification/`, {
                        data: {
                            template: id
                        }
                    })
                    .then((response) => {
                        this.$swal.fire({
                            icon: "success",
                            title: "Қониқарли. Ҳисобот намунаси учирилди",
                            title: this.$i18n.locale === 'cyr' ? "Қониқарли. Ҳисобот намунаси учирилди" : "Удовлетворительно. Образец отчёта удалён.",
                            timer: 3000,
                        });
                        this.getReportsList();
                    })
                    .catch((error) => {
                        this.$swal.fire({
                            icon: "error",
                            title: this.$i18n.locale === 'cyr' ? "Ҳисобот намунасини учиришда хатолик" : "Ошибка при удалении образца отчета.",
                            timer: 3000,
                        });
                    });
            });
        },
        downloadReport(data) {
            this.loadingDownload = true
            axios({
                url: `/building/export/specification/`,
                method: 'POST',
                responseType: 'blob',
                data: { template: data.id }})
                .then(response => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${data.file_name}.xlsx`);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                })
                .catch((error) => {
                    this.$swal.fire({
                        icon: "error",
                        title: this.$i18n.locale === 'cyr' ? "Ҳисобот намунасини юклашда хатолик" : "Ошибка при загрузке образца отчета.",
                        timer: 3000,
                    });
                })
                .finally(() => {
                    this.loadingEditReport = false;
                });
        },
        onDrop(dropResult) {
            const { removedIndex, addedIndex, payload } = dropResult;
            if (removedIndex === null && addedIndex === null) return;

            const result = [...this.report.fields];
            let itemToAdd = payload;

            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0];
            }

            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd);
            }

            this.report.fields = result;
        }

    },
};
</script>

<style lang="scss" scoped>
.draggable__fields{
    margin-top: 20px;
}
.draggable-item{
    background: #F1F5F9;
    color: #1E293B;
    border-radius: 8px;
    padding: 8px 12px;
    line-height: 1.375;
    font-weight: 600;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: move;
}
.all-reports {
    width: 100%;
}

.reports-card {
    padding: 5px !important;
    min-width: 400px;
}

.report__card {
    width: 100%;
    padding: 16px;
    background: #F8FAFC;
    border-radius: 20px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (max-width: 576px) {
        padding: 12px;
        border-radius: 8px;
    }
    &-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 8px;
    }

    &-title {
        font-weight: 700;
        font-size: 20px;
        line-height: 1.375;
        color: #020617;
        @media screen and (max-width: 576px) {
            font-size: 18px;
        }
    }

    &-select {
        flex: 1;

        .el-select {
            width: 100%;
            min-width: 150px;
        }

    }

    &-body {
        padding-top: 8px;
        display: grid;

        .report__select {
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            margin-bottom: 8px;
        }
    }

    .report__download {
        border-radius: 12px;
        padding: 7px 11px;
        background: #ffffff;
        border: 1px solid #E2E8F0;
        box-shadow: 0px 1px 2px 0px #0000000D;
        display: flex;
        gap: 8px;
        text-align: left;
        align-items: center;
        @media screen and (max-width: 576px) {
            border-radius: 12px;
            padding: 4px 8px;
        }

        &-icon {
            width: 40px;
            height: 40px;
            object-fit: contain;
            @media screen and (max-width: 576px) {
                width: 30px;
                height: 30px;
            }
        }

        &-text {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        &-title {
            color: #020617;
            font-weight: 500;
            font-size: 16px;
            line-height: 1.375;
            @media screen and (max-width: 576px) {
                font-size: 14px;
            }
        }


        &-subtitle {
            color: #F59E0B;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
        }

        &-action {
            width: 40px;
            height: 40px;
            border-radius: 12px;
            background: #EEF2FF;
            display: flex;
            justify-content: center;
            align-items: center;
            @media screen and (max-width: 576px) {
                width: 30px;
                height: 30px;
                border-radius: 8px;
            }

            img {
                width: 24px;
                height: 24px;
                object-fit: contain;
                @media screen and (max-width: 576px) {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        button {
            width: 40px;
            height: 40px;
            border-radius: 12px;
            color: #3730A3;
            background: #EEF2FF;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .report__card-body-title {
        font-size: 14px;
        font-weight: 600;
    }
}

.report-download {
    cursor: pointer;
    border-radius: 12px;
    padding: 7px 15px;
    background: #ffffff;
    color: #020617;
    font-size: 16px;
    line-height: 22px;
    border: 1px solid #E2E8F0;
    box-shadow: 0px 1px 2px 0px #0000000D;

    button {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        color: #3730A3;
        background: #EEF2FF;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.cut-text {
    text-overflow: ellipsis !important;
    max-width: 700px !important;
    white-space: nowrap !important;
}

.hr {
    width: 100%;
    height: 2px;
    background: #E2E8F0;
    margin: 20px 0;
}

.constructor__top {
    background: #F8FAFC;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    border-radius: 12px;

    &-logo {
        width: 40px;
        height: 40px;
        margin-right: 12px;
    }

    &-title {
        flex: 1;
        font-size: 24px;
        line-height: 1.375;
        font-weight: 700;
        color: #3730A3;

        span {
            color: #0891B2;
        }
    }

    &-info {
        margin: 0 20px;
        padding: 4px 10px;
        border-radius: 8px;
        background: #EEF2FF;
        color: #1E3A8A;
        font-size: 16px;
        line-height: 1.375;
        font-weight: 700;
    }
    @media screen and (max-width: 576px) {
        &-title {
            font-size: 18px;
        }
        &-info {
            margin: 10px 0 0 0;
            font-size: 14px;
        }
    }
}
.constructor__body{
    margin-top: 20px;
    background: #F8FAFC;
    border-radius: 20px;
    padding: 16px;
    &-title{
        color: #94A3B8;
        margin-bottom: 8px;
        font-weight: 600;
        line-height: 1.375;
    }
}

.step {
    display: flex;
    gap: 20px;

    &__item {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    &__number {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #EEF2FF;
        color: #3730A3;
        font-weight: 500;
        font-size: 14px;
        border-radius: 8px;
        width: 36px;
        height: 36px;
    }

    &__text {
        color: #6B7280;
        font-weight: 600;
    }

    .active {
        .step__number {
            background: #3730A3;
            color: white;
        }

        .step__text {
            color: #1F2937;
        }
    }
    @media screen and (max-width: 576px) {
        gap: 8px;

        &__item {
            gap: 6px;
        }

        &__number {
            font-size: 14px;
            border-radius: 8px;
            width: 28px;
            height: 28px;
        }

        &__text {
            font-size: 14px;
        }
        
    }

}

.report_hr {
    margin: 20px 0;
    width: 100%;
    height: 1px;
    background: #E2E8F0;
}

.report_exemples{
    border: 1px solid #E2E8F0;
    background: #FFFFFF;
    box-shadow: 0px 1px 2px 0px #0000000D;
    border-radius: 12px;
    padding: 8px 12px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    align-items: center;
    gap: 8px;
    &-text{
        flex: 1;
    }
    &-title{
        font-size: 14px;
        line-height: 1.375;
        font-weight: 600;
        color: #020617;
    }
    &-subtitle{
        font-size: 14px;
        line-height: 1.375;
        font-weight: 400;
        color: #94A3B8;
    }
    &-buttons{
        button{
            width: 40px;
            height: 40px;
            border-radius: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.3 ease;
            > svg{
                width: 24px;
                height: 24px;
            }
        }
        &--download{
            background: #EEF2FF;
            color: #3730A3;
            &:hover{
                background: #E0E7FF;
            }
        }
        &--edit{
            background: #EFFDF5;
            color: #059669;
            &:hover{
                background: #D9FBE8;
            }
        }
        &--delete{
            background: #FFF1F2;
            color: #E11D48;
            &:hover{
                background: #FFE4E6;
            }
        }
        @media screen and (max-width: 576px) {
            button{
                width: 32px;
                height: 32px;
                border-radius: 8px;
                > svg{
                    width: 20px;
                    height: 20px;
                }
            }
            
        }
    }
    
}

</style>
